import PropTypes from 'prop-types';
import React, {Component} from 'react';

import {events} from 'lib';

import CustomerApi from 'api/customer';
import {demergeContact} from 'api/dataCleanup';
import Customer from 'models/customer';
import CustomerContact from 'models/customerContact';

import ValidationGroup from 'helpers/validation';
import {join} from 'helpers/functionalJsx';

import {Col, Row} from 'components';
import {Button, ConfirmationModal} from 'components/layout';
import ContactCard from 'components/tools/ContactCard';
import Callout from 'components/tools/Callout';

import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class Split extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customer: new Customer({}),
      toDelete: new Set(),
      firstDeleted: false,
      secondDeleted: false,
      confirmVisible: false,
    };

    this.group = new ValidationGroup(this.open);
  }

  componentWillMount() {
    CustomerApi.getCustomer(this.props.selectedContact.cId)
      .then(cust => {
        this.setState({customer: cust});
      });
  }

  close = () => {
    this.setState({
      confirmVisible: false,
    });
  };

  delete = id => {
    return () => {
      const toDelete = this.state.toDelete;

      toDelete.add(id);
      this.setState({toDelete});
    };
  };

  deleteNew = num => {
    if (num === 1) {
      this.setState({
        firstDeleted: true,
      });
    } else {
      this.setState({
        secondDeleted: true,
      });
    }
  };

  open = () => {
    this.setState({
      confirmVisible: true,
    });
  };

  split = () => {
    const original = new CustomerContact({
      id: parseInt(this.props.selectedContact.Id.split('.')[1]),
      customerID: this.props.selectedContact.cId,
    });

    const first = this.firstContact.getContact();
    const second = this.secondContact.getContact();

    const newContacts = [first, second]
      .filter(x => !!x)
      .map(x => {
        x.customerID = this.props.selectedContact.cId;
        return x;
      });

    demergeContact(original, newContacts, [...this.state.toDelete])
      .then(() => {
        events.publish('success.user', {message:
  <span><FormattedMessage id="tools.split.contact.split" />. {join(newContacts.map(x => <Callout href={'#customer/' + this.state.customer.id}>{x.name}</Callout>),
    <span>&nbsp;&amp;&nbsp;</span>)} <FormattedMessage id="general.account.number" />: <Callout href={'#customer/' + this.state.customer.id}>
      {this.state.customer.accountNum}
    </Callout>
  </span>});
        this.setState({confirmVisible: false});
        this.props.updateResults(res => {
          return res.filter(y => y.Id !== this.props.selectedContact.Id);
        });
        this.props.addToBlacklist(this.props.selectedContact.Id);
      })
      .catch(err => {
        console.error(err);
      });
  };

  render() {
    const selectedContact = this.props.selectedContact;
    const selectedID = parseInt(selectedContact.Id.split('.')[1]);

    // Matches and, &, or /. And requires spaces the others don't.
    const splitFirst = selectedContact.firstName.split(/[\s]*&[\s]*|[\s]+and[\s]+|[\s]*\/[\s]*/i);
    const nameA = splitFirst[0];
    const nameB = splitFirst[1];

    return <div className='split-contacts'>
      <ConfirmationModal dismissKey='DISMISS_SPLIT_CONTACT' message={`Click 'Confirm' to split the contacts.`}
        submitLabel='Confirm' onSubmit={this.split} onClose={this.close} visible={this.state.confirmVisible} />

      <Row>
        <Col md={8} className='split-contacts__split-container'>
          <h3 className='blue'><FormattedMessage id="tools.split.contact" /></h3>
          <p style={{marginTop: 20}}><FormattedMessage id="tools.split.recommended.changes" /></p>

          <Row>
            <Col md={6}>
              <ContactCard outlined firstName={nameA} lastName={selectedContact.lastName} email={selectedContact.email} delete={() => this.deleteNew(1)}
                homePhone={selectedContact.homePhone} alternatePhone={selectedContact.mobilePhone || selectedContact.workPhone}
                deleted={this.state.firstDeleted} ref={f => this.firstContact = f} group={this.group} />
            </Col>

            <Col md={6}>
              <ContactCard outlined firstName={nameB} lastName={selectedContact.lastName} email={selectedContact.email} delete={() => this.deleteNew(2)}
                homePhone={selectedContact.homePhone} alternatePhone={selectedContact.mobilePhone || selectedContact.workPhone}
                deleted={this.state.secondDeleted} ref={s => this.secondContact = s} group={this.group} />
            </Col>

            <Col md={12}>
              <div className='pull-right'>
                <Button default onClick={this.props.cancelSplit} style={{marginRight: 15}}><FormattedMessage id="general.cancel" /></Button>
                <Button primary onClick={this.group.validate}><FormattedMessage id="general.save" /></Button>
              </div>
            </Col>
          </Row>
        </Col>

        <Col md={4} className='split-contacts__other-container'>
          <h3 className='blue'><FormattedMessage id="tools.split.other.contacts" /></h3>
          {(this.state.customer.customerContacts || [])
            .filter(cc => cc.id !== selectedID)
            .map(cc => <ContactCard readOnly firstName={cc.nameFirst} lastName={cc.nameLast} email={cc.email} deleted={this.state.toDelete.has(cc.id)}
              homePhone={cc.homePhone} alternatePhone={cc.workPhone || cc.mobilePhone} key={cc.id} delete={this.delete(cc.id)} />)}
        </Col>
      </Row>
    </div>;
  }
}
Split.propTypes = {
  selectedContact: PropTypes.object.isRequired,
  cancelSplit: PropTypes.func.isRequired,
  updateResults: PropTypes.func.isRequired,
  addToBlacklist: PropTypes.func.isRequired,
};

export default injectIntl(Split);
